export const telegram = "/assets/icons/telegram.svg";
export const facebook = "/assets/icons/facebook.svg";
export const instagram = "/assets/icons/instagram.svg";
export const tiktok = "/assets/icons/tiktok.svg";
export const mail = "/assets/icons/mail.svg";

export const alert_outlined = "/assets/icons/alert_outlined.svg";
export const alert_outlined_white = "/assets/icons/alert_outlined_white.svg";

export const arrow_down = "/assets/icons/arrow_down.svg";
export const arrow_left = "/assets/icons/arrow_left.svg";
export const arrow_right = "/assets/icons/arrow_right.svg";

export const audit_outlined = "/assets/icons/audit_outlined.svg";
export const read_outlined = "/assets/icons/read_outlined.svg";
export const team_outlined = "/assets/icons/team_outlined.svg";
export const breadcrumb_home = "/assets/icons/breadcrumb_home.svg";
export const breadcrumb_separator = "/assets/icons/breadcrumb_separator.svg";
export const read_outlined_white = "/assets/icons/read_outlined_white.svg";
export const reconciliation_outlined = "/assets/icons/reconciliation_outlined.svg";
export const snippets_outlined = "/assets/icons/snippets_outlined.svg";
export const solution_outlined = "/assets/icons/solution_outlined.svg";
export const calendar_outlined = "/assets/icons/calendar_outlined.svg";
export const goal = "/assets/icons/goal.svg";
export const vision = "/assets/icons/vision.svg";
export const heart_outlined = "/assets/icons/heart_outlined.svg";
export const heart_outlined_white = "/assets/icons/heart_outlined_white.svg";
export const star_outlined = "/assets/icons/star_outlined.svg";
export const smile_outlined = "/assets/icons/smile_outlined.svg";
export const oops = "/assets/icons/oops.svg";


